import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
import getSavedState from '../../utils/get-state'
import saveState from '../../utils/save-state'
import store from '../store'

// const headers = {
//   'Content-Type': 'application/json',
//   Authorization: axios.defaults.headers.common.Authorization,
// }

export const state = {
  masterData: getSavedState('masterData'),
  isMasterDataLoading: getSavedState('isMasterDataLoading'),
  selectedTimeZone: getSavedState('selectedTimeZone'),
}

export const getters = {
  isMasterDataLoading: (state) => {
    return state.isMasterDataLoading
  },

  selectedTimeZone: (state) => {
    return state.selectedTimeZone
  },
  portfolioList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'XpPortfolioType', {
      text: 'value1',
      value: 'value1',
      stateCode: 'value2',
    })
  },
  allStates(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'State', {
      text: 'value1',
      value: 'id',
      stateCode: 'value2',
    })
  },

  suffixes(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'Suffix', {
      text: 'value1',
      value: 'id',
      stateCode: 'value2',
    })
  },

  CCRLoanTypes(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'CCRLoanType', {
      text: 'value1',
      value: 'id',
      loanTypeCode: 'value1',
    })
  },

  maritalStatuses(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'MaritalStatus', {
      text: 'value1',
      value: 'id',
      maritalStatusCode: 'value1',
    })
  },

  allTimeZones(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'TimeZone', {
      text: 'value1',
      value: 'id',
      timeZone: 'value2',
    })
  },

  allDateTimeFormats(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'DateTimeFormat', {
      text: 'value1',
      value: 'id',
      dateTimeFormat: 'value2',
    })
  },

  salutationList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'Salutation', {
      text: 'value1',
      value: 'id',
    })
  },
  supplementStatusList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'SupplementStatus', {
      text: 'value1',
      value: 'id',
    })
  },
  rescoreStatusList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'RescoreStatus', {
      text: 'value1',
      value: 'id',
    })
  },

  rescoreTradelineStatusList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'RescoreTradelineStatus', {
      text: 'value1',
      value: 'id',
    })
  },
  requestTypesList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'RequestType', {
      text: 'value1',
      value: 'id',
    })
  },
  transactionHistoryList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'TransactionHistory', {
      text: 'value1',
      value: 'id',
    })
  },
  refreshPeriodList(state) {
    const masterData = state.masterData
    return __getKeyValue2(masterData, 'RefreshPeriod', {
      text: 'value1',
      value: 'id',
    })
  },
  // accountTypeList(state) {
  //   const masterData = state.masterData
  //   const accountTypeList = []

  //   if (masterData !== null) {
  //     let i = 0
  //     for (i = 0; i < masterData.length; i++) {
  //       if (masterData[i].key === 'AccountType') {
  //         // if (masterData[i].key.localeCompare('AccountType') === 0) {
  //         accountTypeList.push({
  //           value: masterData[i].id,
  //           text: masterData[i].value1,
  //         })
  //       }
  //     }
  //   }
  //   console.log(accountTypeList)
  //   return accountTypeList
  // },

  cities(state) {
    const masterData = state.masterData

    const cityList = []

    if (masterData !== null) {
      let i = 0
      for (i = 0; i < masterData.length; i++) {
        if (masterData[i].key === 'City') {
          cityList.push(masterData[i].value3)
        }
      }
    }
    return cityList
  },

  formattedCities(state) {
    const masterData = state.masterData
    const cityList = []

    if (masterData !== null) {
      let i = 0
      for (i = 0; i < masterData.length; i++) {
        if (masterData[i].key === 'City') {
          const city = masterData[i]
          delete city.key
          delete city.displayOrder
          cityList.push(city)
        }
      }
    }

    return cityList
  },

  counties(state) {
    const masterData = state.masterData
    const countyList = []

    if (masterData !== null) {
      let i = 0
      for (i = 0; i < masterData.length; i++) {
        if (masterData[i].key === 'County') {
          countyList.push(masterData[i].value2)
        }
      }
    }

    return countyList
  },

  formattedCounties(state) {
    const masterData = state.masterData
    const countyList = []

    if (masterData !== null) {
      let i = 0
      for (i = 0; i < masterData.length; i++) {
        if (masterData[i].key === 'County') {
          const county = masterData[i]
          delete county.key
          delete county.displayOrder
          countyList.push(county)
        }
      }
    }

    return countyList
  },

  masterData(state) {
    return state.masterData
  },
}

function __getKeyValue2(array, key, objType) {
  if (array && Array.isArray(array)) {
    return array
      .filter((x) => x.key === key)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((item) => {
        let obj = {}
        Object.keys(objType).forEach((k) => {
          obj[k] = item[objType[k]]
        })
        return obj
      })
  }
  return []
}

export const mutations = {
  SET_MASTER_DATA(state, payload) {
    state.masterData = payload
    saveState('masterData', payload)
  },

  SET_MASTER_DATA_LOADING(state, payload) {
    state.isMasterDataLoading = payload
    saveState('isMasterDataLoading', payload)
  },

  RESET_MASTER_DATA(state) {
    state.masterData = []
    saveState('masterData', [])
    state.selectedTimeZone = null
    saveState('selectedTimeZone', null)
  },

  SET_SELECTED_TIMEZONE(state, selectedTimeZone) {
    state.selectedTimeZone = selectedTimeZone.text
    state.isMasterDataLoading = false
    saveState('selectedTimeZone', selectedTimeZone.text)
    saveState('isMasterDataLoading', false)
  },
}

export const actions = {
  async fetchMasterData({ commit }) {
    commit('SET_MASTER_DATA_LOADING', true)
    return axios
      .get(`${appConfig.apiEndPoint}${endpoint.adminApiPath.getmasterdata}`, {
        headers: setHeaders(),
      })
      .then((response) => {
        commit('SET_MASTER_DATA', response.data)
        return response
      })
      .catch((error) => {
        throw error
      })
  },

  setSelectedTimeZone({ getters, commit }, timeZone) {
    const allTimeZones = getters.allTimeZones
    const selectedTimeZone = allTimeZones.find((tz) => tz.value === timeZone)

    commit('SET_SELECTED_TIMEZONE', selectedTimeZone)
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
